<div class="o-grid">
    <div [class.hidden]="!formValue().useFlightDate">
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">Rental car pick-up/drop-off details are the same as for flight</div>
            </div>
        </div>
        @let request = request$ | async;
        @defer (when request) {
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Airport (Destination)</h5>
                        <span id="destinationAirport">{{ request.flightRequestDetails?.airportDestination }}</span>
                    </div>
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__item half">
                    <div class="c-info__block">
                        <h5>Departure date</h5>
                        <span id="departureDate">{{
                            request.flightRequestDetails?.departureDate?.toDate() | dateFormat | uppercase
                        }}</span>
                    </div>
                </div>
                @if (request.flightRequestDetails?.travelType === TravelType.ROUND_TRIP) {
                    <div class="o-grid__item half">
                        <div class="c-info__block">
                            <h5>Return date</h5>
                            <span id="returnDate">{{
                                request.flightRequestDetails?.returnDate?.toDate() | dateFormat | uppercase
                            }}</span>
                        </div>
                    </div>
                }
            </div>
        }
    </div>

    <div [class.hidden]="formValue().useFlightDate">
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Pick-up Airport Or City</h5>
                    <span id="pickupAddress">{{ formValue().pickupAddress }}</span>
                </div>
            </div>
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Country</h5>
                    <span id="pickupCountry">{{ formValue().pickupCountry }}</span>
                </div>
            </div>
        </div>
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Pick-up Date</h5>
                    <span id="pickupDate">{{ formValue().pickupDate?.toDate() | dateFormat | uppercase }}</span>
                </div>
            </div>
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Pick-up Time</h5>
                    <span id="pickupTime">{{
                        getDateFromMinutesSinceMidnight(formValue().pickupTime)?.toDate() | dateFormat: 'shortTime'
                    }}</span>
                </div>
            </div>
        </div>
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Drop-off Date</h5>
                    <span id="dropOffDate">{{ formValue().dropOffDate?.toDate() | dateFormat | uppercase }}</span>
                </div>
            </div>
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Drop-off Time</h5>
                    <span id="dropOffTime">{{
                        getDateFromMinutesSinceMidnight(formValue().dropOffTime)?.toDate() | dateFormat: 'shortTime'
                    }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="o-grid__row">
        <div class="o-grid__item">
            <div class="c-info__block">
                <h5>Special Requests</h5>
                <span id="specialRequests">{{ formValue().specialRequests ?? 'Unspecified' }}</span>
            </div>
        </div>
    </div>
</div>
